export function buildTeacherAssignmentPayloads({
  teacherId,
  campusId,
  selectedCourseIds,
  courses,
  existingAssignments = [],
}) {
  const newAssignments = [];
  const alreadyAssigned = [];

  const selectedSet = new Set(selectedCourseIds.map(String));

  courses.forEach((course) => {
    const courseIdStr = String(course.id ?? course.course_id);
    if (!selectedSet.has(courseIdStr)) return;

    const normalizedCourseId = course.course_id ?? course.id;
    const isDuplicate = existingAssignments.some(
      (c) =>
        String(c.course_id) === String(normalizedCourseId) &&
        (c.class_id == null || course.class_id == null || String(c.class_id) === String(course.class_id))
    );

    if (isDuplicate) {
      alreadyAssigned.push(course);
    } else {
      newAssignments.push({
        teacher_id: teacherId,
        course_id: normalizedCourseId,
        campus_id: campusId,
        class_id: course.class_id ?? null,
        section: null,
        session_id: null,
      });
    }
  });

  return { newAssignments, alreadyAssigned };
}
